import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const examples = [
  { text: "For contractors: Never lose an emergency call", color: "text-orange-400" },
  { text: "For consultants: Book meetings while you're with clients", color: "text-indigo-400" },
  { text: "For salons: Fill cancellations automatically", color: "text-pink-400" },
  { text: "For restaurants: Take reservations 24/7", color: "text-red-400" },
];

export const IndustryRotator = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % examples.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="relative w-full text-center lg:text-left h-full">
      <AnimatePresence mode="wait">
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.5 }}
          className={`text-lg font-medium ${examples[index].color} absolute w-full`}
        >
          {examples[index].text}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};
